import React from 'react';
import './SkeletonCard.css';

const SkeletonCard = ({ delay = 0 }) => {
  return (
    <div className="skeleton-card" style={{ animationDelay: `${delay}ms` }}>
      <div className="skeleton-header">
        <div className="skeleton-avatar"></div>
        <div className="skeleton-user-info">
          <div className="skeleton-name"></div>
          <div className="skeleton-handle"></div>
        </div>
      </div>
      <div className="skeleton-content">
        <div className="skeleton-text-line skeleton-text-long"></div>
        <div className="skeleton-text-line skeleton-text-medium"></div>
        <div className="skeleton-text-line skeleton-text-short"></div>
      </div>
      <div className="skeleton-footer">
        <div className="skeleton-stat"></div>
        <div className="skeleton-stat"></div>
        <div className="skeleton-stat"></div>
      </div>
    </div>
  );
};

export default SkeletonCard;